/**
 * Merge a saved config over freshly built defaults.
 *
 * The operator app and the API deploy separately, so this bundle can reach a
 * browser a release before the server that fills its payloads in. Taking the
 * API's object verbatim means a field this build knows about and that server
 * does not arrives `undefined`, and any page that reads it -- literally
 * `avatar.initials.trim()` -- dies in render behind an error boundary. The
 * same thing happens in reverse for a tenant whose row was written before a
 * field existed. Merging over the defaults turns both into a default value and
 * a page that draws.
 *
 * Rules, applied per key:
 *   - array default: the saved value when it is an array, else the default
 *   - object default: merged key by key, recursively
 *   - anything else (including a `null` default): the saved value, unless the
 *     key is absent
 *
 * Keys the defaults do not declare are dropped. This is a whitelist on
 * purpose: a payload that grows a field cannot smuggle it into a draft the UI
 * would save back having never shown it.
 */
export function mergeOverDefaults(defaults, saved) {
  if (Array.isArray(defaults)) {
    return Array.isArray(saved) ? [...saved] : defaults;
  }
  if (defaults !== null && typeof defaults === "object") {
    if (saved === null || typeof saved !== "object" || Array.isArray(saved)) return defaults;
    const merged = { ...defaults };
    for (const [key, fallback] of Object.entries(defaults)) {
      // `in` rather than a truthiness check: `false`, `0` and `""` are all
      // values a tenant can have saved deliberately.
      if (!Object.prototype.hasOwnProperty.call(saved, key)) continue;
      merged[key] = mergeOverDefaults(fallback, saved[key]);
    }
    return merged;
  }
  return saved === undefined ? defaults : saved;
}
